import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Slider from 'react-slick';
// import _ from 'underscore';
import { acChangeActiveLot } from '../actions/acChangeActiveLot'
// import { acExtrageri } from '../actions/acExtrageri'

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, display: 'block', backgroundImage: 'url(img/slider/arrow_right.jpg) ' }}
            onClick={onClick}
        ></div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, display: 'block', backgroundImage: 'url(img/slider/arrow_left.jpg) ' }}
            onClick={onClick}
        ></div>
    );
}

class SimpleSlider extends React.Component {

    changeActive() {
        // var filtru = _.findWherehere(this.props.loterii, { name_lot: "Grecia Kino" })
        // this.props.acChangeActiveLot(filtru[0]);
        // this.props.acExtrageri(val.replace(/ /g, "_"));
    }

    render() {
        var settings = {

            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
        }
        return (

            <Slider {...settings}>
                {/* <div><a href="https://casino.netbet.ro/keno-loto-promo" target="_blank"><img src="img/wild_loto_race_724x300.jpg" alt="" /></a></div> */}
                {/* <div><a href="https://casino.netbet.ro/cufar-loto-promo " target="_blank" rel="noopener noreferrer"><img src="img/loto_treasures_724x300.jpg" alt="" /></a></div> */}
                <div onClick={this.changeActive.bind(this)}><img src="img/slider/grecia.jpg" alt="" /></div>
                <div><a href="https://casino.netbet.ro/lotoro-promotion" target="_blank" rel="noopener noreferrer"><img src="img/slider/pimgpsh.jpg" alt="" /></a></div>
            </Slider>

        );
    }
}

function mapStateToProps(state) {
    return {
        loterii: state.loterii,
    }
}
//  acBileteMob: acBileteMob,
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acChangeActiveLot: acChangeActiveLot,
        // acExtrageri: acExtrageri
    }, dispatch)
}
// export default ColoanaMid;
export default connect(mapStateToProps, matchDispatchToProps)(SimpleSlider);
// export default SimpleSlider;